exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box[data-v-0996e3be] {\n  height: 100%;\n}\n", ""]);

// exports
